export default __webpack_public_path__ + "static/media/slide-1-mob.fa056cb9.jpg";